import Vue from 'vue'
import VueRouter from 'vue-router'
import store from '@/store'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    component:  () => import('@/views/home'),
    redirect: '/home',
    meta: { requiresAuth: false } // 不需要认证
  },
  {
    path: '/home',
    name: 'home',
    component:  () => import('@/views/home'),
    meta: { requiresAuth: false } // 不需要认证
  },
]

const router = new VueRouter({
  mode: 'history',
  scrollBehavior: () => ({ y: 0 }),
  routes
})

  // 路由守卫
router.beforeEach(async (to, from, next) => {
  const isLoggedIn = store.getters['user/isLoggedIn']
  
  // 检查路由是否需要认证
  if (to.matched.some(record => record.meta.requiresAuth)) {
    if (!isLoggedIn) {
      // 未登录，重定向到用户中心服务
      try {
        // 重定向到用户中心登录
        const redirectUri = encodeURIComponent(window.location.origin + '/home')
        const state = await store.dispatch('auth/generateState')

        // 检查环境变量是否已设置
        if (!process.env.VUE_APP_AUTH_CENTER_URL || !process.env.VUE_APP_CLIENT_ID) {
          console.error('环境变量未正确设置:', {
            VUE_APP_AUTH_CENTER_URL: process.env.VUE_APP_AUTH_CENTER_URL,
            VUE_APP_CLIENT_ID: process.env.VUE_APP_CLIENT_ID
          })
          throw new Error('认证中心配置错误，请检查环境变量设置')
        }

        // 添加重定向参数，认证完成后返回当前页面
        const authUrl = `${process.env.VUE_APP_AUTH_CENTER_URL}/login?redirect=${redirectUri}&type=login&state=${state}&response_type=code&client_id=${process.env.VUE_APP_CLIENT_ID}`
        console.log('authUrl', authUrl)
        window.location.href = authUrl
      } catch (error) {
        console.error('重定向到用户中心失败:', error)
        // 这里不能使用this.$message，因为路由守卫中没有Vue实例
        // 可以跳转到错误页面或显示其他提示
        next('/home')
      }
    } else {
      // 已登录，允许访问
      next()
    }
  } else {
    // 不需要认证的路由，直接放行
    next()
  }
})

// 全局后置钩子
router.afterEach((to) => {
  // 可以在这里添加页面访问统计等
  document.title = to.meta.title ? `${to.meta.title} - 云间漫步` : '云间漫步'
})

export default router
